"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
var translation_provider_1 = require("./translation-provider");
__export(require("./translation-provider"));
function createTranslationProvider(factory, payload, provider) {
    return new translation_provider_1.TranslationProvider(factory, payload, provider);
}
exports.createTranslationProvider = createTranslationProvider;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@qwentes/models/lib/packages/translation/index.js
// module id = 257
// module chunks = 0